<template>
  <VcNoticeModal
    @onCloseButtonClicked="$emit('onCancelClicked')"
    :showDialog="true"
    :size="size"
    :useOffset="false"
    :icon="upgradeContent.icon"
    :title-text="$t(upgradeContent.title)"
    :subtitle-text="$t(upgradeContent.subtitle)"
    :okButtonLabel="$t(upgradeContent.approveLabel)"
    :cancelButtonLabel="$t(upgradeContent.approveLabel)">
    <template v-slot:content v-if="upgradeContent.bullets.length">
      <div class="upgrade-popup__content">
          <ul class="upgrade-popup__list">
            <li v-for="bullet in upgradeContent.bullets" class="upgrade-popup__item">
              <VcIcon class="upgrade-popup__bullet-icon">icon-check</VcIcon>
              <span>{{ $t(bullet) }}</span>
            </li>
          </ul>
          <p v-if="upgradeContent.bottomText" class="upgrade-popup__bottom-text">{{ bottomText }}</p>
      </div>
    </template>
    <template v-slot:footer>
      <div class="upgrade-popup__footer">
        <VcModalFooter class="VcNoticeFooter"
                       direction="vertical"
                       :buttons="buttons"
                       @onCancelClicked="$emit('onCancelClicked')"
                       @onOkClicked="$emit('onOkClicked')" />
      </div>
    </template>
  </VcNoticeModal>
</template>

<script>
  import { getUpgradePopUpContent } from './upgradePopUpService'
  import { mapGetters } from "vuex";
  export default {
    name: "UpgradePopUp",
    props: {
      showUpgradeDialog: {
        type: Boolean,
        required: true
      },
      upgradeButtonLabel: {
        type: String,
        default: 'client.upload_documents_dialog.upgrade_cta'
      },
      cancelButtonLabel: {
        type: String,
        default: 'client.upload_documents_dialog.cancel_cta'
      },
      size: {
        type: String,
        default: 'lg',
        validator: prop => ['lg', 'md'].includes(prop),
      },
      upgradeName: {
        type: String,
        required: true
      },
    },
    data() {
      return {
        upgradeContent: null
      }
    },
    created() {
      this.upgradeContent = getUpgradePopUpContent({ upgradeName: this.upgradeName });
    },
    computed: {
      ...mapGetters(['isIosMobileApp']),
      cancelCta() {
        return this.isIosMobileApp ? 'client.upload_documents_dialog.close_cta' : this.cancelButtonLabel
      },
      allButtons() {
        return [
          { label: this.upgradeButtonLabel, event: "onOkClicked", color: "secondary"},
          { label: this.cancelCta, event: "onCancelClicked", color: "white" }
        ].map(b => Object.assign(b, { label: this.$t(b.label) }))
      },
      buttons() {
        const [ first, second ] = this.allButtons;
        return this.isIosMobileApp ? [ second ] : [ first, second ]
      },
    },
  };
</script>
<style lang="scss">
  @import "@/assets/scss/abstract/variables";
  @import "@/assets/scss/abstract/mixins";

  .upgrade-popup {

    &__content {
      margin-bottom: 4px;
    }

    &__footer {
      margin-bottom: 14px;
    }

    &__list {
      background-color: $green-color-3;
      border: 1px solid $green-color-4;
      border-radius: 8px;
      width: 100%;
      list-style: none;
      padding: 14px 0;
      margin: 14px 0;
      text-align: left;

      html[dir='rtl'] & {
        text-align: right;
      }
    }

    &__item {

      &:not(:last-child) {
        margin-bottom: 8px;
      }
    }

    &__bullet-icon {
      margin-inline-end: 12px;

      &:before {
        color: $green-color-5;
      }
    }

    &__bottom-text {
      margin-top: 14px;
    }
  }

</style>
